import { TIconProps } from './utils';

export const CrossWhiteIcon = ({ className = '' }: TIconProps) => (
  <svg
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    width='33'
    height='33'
    viewBox='0 0 33 33'
    fill='none'
  >
    <path
      d='M27.5 26.583L5.5 4.58301M27.5 4.58301L5.5 26.583'
      stroke='white'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
);
